import { z } from "zod";
import { EmployeeItemSchema } from "./employee-item";
import { ResultDataSchema } from "../result-data/result-data";

export const EmployeeResultSchema = ResultDataSchema.extend({
  Results: EmployeeItemSchema.array(),
});

export type EmployeeResultType = z.infer<typeof EmployeeResultSchema>;
